export const getDashboardPathForUser = (
  planTier?: string | null,
  organizationType?: string | null,
  isEnterpriseMember?: boolean | null,
): string | null => {
  const tier = (planTier ?? '').toLowerCase().trim();
  const orgType = (organizationType ?? '').toLowerCase().trim();

  if (tier === 'enterprise' || isEnterpriseMember) {
    return '/enterprise/dashboard';
  }

  if (tier === 'startup' || orgType === 'startup') {
    return '/startup/dashboard';
  }

  if (tier === 'government_state' || tier === 'government_federal' || orgType.includes('government')) {
    return '/government/dashboard';
  }

  return null;
};
